import { Offers } from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  AEMErrorMessage,
  AEMOffer,
  Card,
  checkErrors,
  getEmptyContent,
  getGenericLabel,
  getImage,
  getLink,
  isDisplay,
  isError,
  isValidData,
  MultiplePersonalizationEngineResponse
} from '@com-delta-idp/mnx-skymiles-shared';
import { ActionType, Image, ImageSize } from '@com-delta-idp/mnx-ui-kit';
import { logError } from '@com-delta-idp/mnx-utils';

export const getOffers = (
  featureFlag: boolean | undefined,
  skymiles: string | undefined,
  multiplePE: MultiplePersonalizationEngineResponse | undefined,
  errors: (string | undefined)[],
  aemErrorMessages: AEMErrorMessage[] | undefined
): Offers => {
  try {
    if (checkErrors(errors, aemErrorMessages)) {
      return isError<Offers>(
        'offers',
        aemErrorMessages as AEMErrorMessage[],
        featureFlag
      );
    }
    return isValidData<
      string,
      [
        string | undefined,
        MultiplePersonalizationEngineResponse | undefined,
        boolean | undefined
      ]
    >('', skymiles, multiplePE, featureFlag)
      ? adaptPartners(
          skymiles as string,
          multiplePE as MultiplePersonalizationEngineResponse,
          featureFlag as boolean
        )
      : isDisplay<Offers>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'OFFERS');
    return getEmptyContent<Offers>('offers', aemErrorMessages, true);
  }
};

const adaptPartners = (
  skymiles: string,
  multiplePE: MultiplePersonalizationEngineResponse,
  featureFlag: boolean
): Offers => {
  if (multiplePE['ng-skymiles:promotional-cards'] && featureFlag) {
    return {
      cards: getOfferCards(
        multiplePE['ng-skymiles:promotional-cards'].parsys.promotional_cards
          .cards
      ),
      disabled: !featureFlag,
      loaded: true
    };
  } else {
    return getEmptyContent<Offers>('', [], true, true);
  }
};

const getOfferCards = (rowCards: string[]): Card[] => {
  const cards: Card[] = [];
  rowCards.forEach((rowCards: string) => {
    const aemCards: AEMOffer = JSON.parse(rowCards);
    aemCards.ctaLabel = getLinkLabel(aemCards);
    cards.push({
      id: aemCards.id,
      type: aemCards.type as ImageSize,
      content: getGenericLabel(aemCards.title, aemCards.description),
      image: getImage(aemCards.image_1, aemCards.title),
      image2: getSecondImage(aemCards),
      tag: { title: aemCards.headline },
      action: {
        type: aemCards.ctaType as ActionType,
        link: getLink(aemCards.ctaLabel, aemCards.ctaURL)
      }
    });
  });
  return cards;
};

export const getLinkLabel = (aemCards: AEMOffer): string => {
  if (aemCards.ctaType === 'caret') {
    return aemCards.title;
  }
  return aemCards.ctaLabel;
};

export const getSecondImage = (aemCards: AEMOffer): Image => {
  const image: Image = getImage(aemCards.image_2, aemCards.title);
  image.show = aemCards.image_2.length > 1;
  return image;
};
